import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  // Schema.org structured data for privacy policy page
  const privacySchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Privacy Policy - Robomec Automation",
    "description": "Privacy Policy for Robomec Automation Private Limited. Learn how we collect, use, and protect your personal data.",
    "url": "https://www.robomecautomation.com/privacy-policy"
  };

  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Privacy Policy for Robomec Automation Private Limited. Learn how we collect, use, and protect your personal data."
        canonicalUrl="https://www.robomecautomation.com/privacy-policy"
        keywords={[
          "Robomec Automation privacy policy",
          "industrial machinery privacy",
          "data protection policy",
          "privacy terms"
        ]}
        schema={privacySchema}
      />
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <h1 className="mb-4">Privacy Policy</h1>
            <p className="text-muted mb-4">Last Updated: November 15, 2023</p>
            
            <h2 className="mt-5 mb-3">1. Introduction</h2>
            <p>
              Welcome to Robomec Automation Private Limited ("Company", "we", "our", "us"). We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.
            </p>
            
            <h2 className="mt-5 mb-3">2. The Data We Collect About You</h2>
            <p>
              Personal data, or personal information, means any information about an individual from which that person can be identified. We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:
            </p>
            <ul>
              <li><strong>Identity Data</strong> includes first name, last name, title, and company name.</li>
              <li><strong>Contact Data</strong> includes email address, telephone numbers, and physical address.</li>
              <li><strong>Technical Data</strong> includes internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website.</li>
              <li><strong>Usage Data</strong> includes information about how you use our website and services.</li>
              <li><strong>Marketing and Communications Data</strong> includes your preferences in receiving marketing from us and your communication preferences.</li>
            </ul>
            
            <h2 className="mt-5 mb-3">3. How We Collect Your Personal Data</h2>
            <p>We use different methods to collect data from and about you including through:</p>
            <ul>
              <li><strong>Direct interactions.</strong> You may give us your Identity and Contact Data by filling in forms or by corresponding with us by post, phone, email, or otherwise.</li>
              <li><strong>Automated technologies or interactions.</strong> As you interact with our website, we may automatically collect Technical Data about your equipment, browsing actions, and patterns.</li>
              <li><strong>Third parties or publicly available sources.</strong> We may receive personal data about you from various third parties and public sources.</li>
            </ul>
            
            <h2 className="mt-5 mb-3">4. How We Use Your Personal Data</h2>
            <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
            <ul>
              <li>To register you as a new customer.</li>
              <li>To process and deliver your order.</li>
              <li>To manage our relationship with you.</li>
              <li>To improve our website, products/services, marketing, or customer relationships.</li>
              <li>To recommend products or services that may be of interest to you.</li>
            </ul>
            
            <h2 className="mt-5 mb-3">5. Data Security</h2>
            <p>
              We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors, and other third parties who have a business need to know.
            </p>
            
            <h2 className="mt-5 mb-3">6. Data Retention</h2>
            <p>
              We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.
            </p>
            
            <h2 className="mt-5 mb-3">7. Your Legal Rights</h2>
            <p>
              Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to:
            </p>
            <ul>
              <li>Request access to your personal data.</li>
              <li>Request correction of your personal data.</li>
              <li>Request erasure of your personal data.</li>
              <li>Object to processing of your personal data.</li>
              <li>Request restriction of processing your personal data.</li>
              <li>Request transfer of your personal data.</li>
              <li>Right to withdraw consent.</li>
            </ul>
            
            <h2 className="mt-5 mb-3">8. Contact Details</h2>
            <p>
              If you have any questions about this privacy policy or our privacy practices, please contact us at:
            </p>
            <address className="mt-3">
              <strong>Robomec Automation Private Limited</strong><br />
              B133, Opp Sukrut Company<br />
              Near Bharat Petroleum Pump<br />
              Bhambholi, Chakan<br />
              Pune 410501, INDIA<br /><br />
            </address>
            
            <h2 className="mt-5 mb-3">9. Changes to the Privacy Policy</h2>
            <p>
              We may update our privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the "Last Updated" date at the top of this policy.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PrivacyPolicy; 